import React from 'react';
import { useTheme } from 'styled-components';

import { Modal } from '../../shared/Components';
import { FlexContainer, Text } from '../../shared/Typhography';
import { strings } from '../../strings';
import { useGlobalModalContext } from '../../context/GlobalModal';
import { DeleteIcon } from '../../assets/Modal';

const DeclineModal = () => {
  const { hideModal, store } = useGlobalModalContext();
  const { modalProps } = store || {};
  const { title, text, deleteButtonComponent } = modalProps || {};
  const { colors } = useTheme();

  const closeModal = () => {
    hideModal();
  };

  return (
    <Modal padding="0" height={440} width={460} closeModal={closeModal} onRequestClose={closeModal}>
      <FlexContainer
        flexDirection="column"
        alignItems="center"
        alignContent="center"
        height="100%"
        justifyContent="center"
        gap="1.2rem"
      >
        <img src={DeleteIcon} alt="Remove" />
        <Text size={2.2} color={colors.black} weight="bold">
          {title}
        </Text>
        <Text size={1} color={colors.gray} weight="bold">
          {text}
        </Text>
        <FlexContainer gap="1rem" alignItems="center" justifyContent="center">
          <Text cursor="pointer" color={colors.gray} onClick={hideModal} weight="bold">
            {strings.cancel}
          </Text>
          {deleteButtonComponent}
        </FlexContainer>
      </FlexContainer>
    </Modal>
  );
};

export default DeclineModal;
